import { selectAccountIdentities } from '@/lib/redux/app.selectors';
import { useSelector } from 'react-redux';

const useShouldValidateIdentity = () => {
  const accountIdentities = useSelector(selectAccountIdentities);
  const shouldValidateIdentity = accountIdentities.length > 1;

  return shouldValidateIdentity;
};

export default useShouldValidateIdentity;
